import React from 'react'
import cx from 'classnames'

import { ArrowPosition } from './constants'
import styles from './TutorialArrow.scss'
import PropTypes from 'prop-types'

export class TutorialArrow extends React.PureComponent {
    static defaultProps = {
        arrowPosition: ArrowPosition.LEFT,
        showBorder: true,
        classNames: {},
    }

    static propTypes = {
        text: PropTypes.element.isRequired,
        onClick: PropTypes.func,
        onCancel: PropTypes.func,
        isHidden: PropTypes.bool,
        showBorder: PropTypes.bool,
        arrowPosition: PropTypes.oneOf(Object.values(ArrowPosition)),
        className: PropTypes.string,
        classNames: PropTypes.shape({
            hint: PropTypes.string,
        }),
    }

    componentDidMount() {
        if (this.props.onCancel) {
            document.addEventListener('click', this.props.onCancel)
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.onCancel !== this.props.onCancel) {
            if (prevProps.onCancel) {
                document.removeEventListener('click', prevProps.onCancel)
            }
            if (this.props.onCancel) {
                document.addEventListener('click', this.props.onCancel)
            }
        }
    }

    componentWillUnmount() {
        if (this.props.onCancel) {
            document.removeEventListener('click', this.props.onCancel)
        }
    }

    render() {
        const {
            isHidden,
            arrowPosition,
            className,
            classNames,
        } = this.props

        if (isHidden) {
            return null
        }

        return (
            <div
                className={cx(
                    styles.base,
                    styles[`base__${arrowPosition}`],
                    className,
                )}
                onClick={this.props.onClick}
            >
                {this.props.showBorder && <div className={styles.border} />}
                <div className={cx(styles.hint, classNames.hint)}>
                    <div className={styles.hintSubstrate} />
                    <div className={styles.hintArrow} />
                    <div className={styles.hintText}>
                        {this.props.text}
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/TutorialArrow/TutorialArrow.jsx